// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderBreakdown_breakdownContainer__iuv5T {
  width: 331px;
  padding: 12px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;

  font-family: "Inter", sans-serif;
}

.OrderBreakdown_breakdownTitle__qHj6X {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #404040;
  margin: 0 0 12px 0;
}

.OrderBreakdown_popoverPaper__KleMn {
  padding: 12px !important;
  border-radius: 8px !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  border: none !important;
}


.OrderBreakdown_childBlock__QdVNP {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.OrderBreakdown_childTitle__UEm5M {
  font-size: 14px;
  font-family: "Inter";
  font-weight: 600;
  margin: 0;
  color: #1a1a1a;
  padding-bottom: 3px;
  border-bottom: 1px solid #e0e0e0;
}

.OrderBreakdown_subjectRow__slx2l {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin:0;
}

.OrderBreakdown_subjectName__awh3E {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: -0.04em;
  color: #404040;
  margin: 0;
}

.OrderBreakdown_expiry__S6GA3 {
  font-size: 12px;
  margin: 0;
  color: #8c8c8c;
  font-family: "Inter", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/OrderBreakdown/index.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC","sourcesContent":[".breakdownContainer {\n  width: 331px;\n  padding: 12px;\n  background: #fafafa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);\n  max-height: 260px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  font-family: \"Inter\", sans-serif;\n}\n\n.breakdownTitle {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #404040;\n  margin: 0 0 12px 0;\n}\n\n.popoverPaper {\n  padding: 12px !important;\n  border-radius: 8px !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  border: none !important;\n}\n\n\n.childBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.childTitle {\n  font-size: 14px;\n  font-family: \"Inter\";\n  font-weight: 600;\n  margin: 0;\n  color: #1a1a1a;\n  padding-bottom: 3px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.subjectRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin:0;\n}\n\n.subjectName {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: -0.04em;\n  color: #404040;\n  margin: 0;\n}\n\n.expiry {\n  font-size: 12px;\n  margin: 0;\n  color: #8c8c8c;\n  font-family: \"Inter\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakdownContainer": `OrderBreakdown_breakdownContainer__iuv5T`,
	"breakdownTitle": `OrderBreakdown_breakdownTitle__qHj6X`,
	"popoverPaper": `OrderBreakdown_popoverPaper__KleMn`,
	"childBlock": `OrderBreakdown_childBlock__QdVNP`,
	"childTitle": `OrderBreakdown_childTitle__UEm5M`,
	"subjectRow": `OrderBreakdown_subjectRow__slx2l`,
	"subjectName": `OrderBreakdown_subjectName__awh3E`,
	"expiry": `OrderBreakdown_expiry__S6GA3`
};
export default ___CSS_LOADER_EXPORT___;
